"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTabsType = void 0;
var SearchTabsType;
(function (SearchTabsType) {
    SearchTabsType["Events"] = "events";
    SearchTabsType["Tournaments"] = "tournaments";
    // mobile app only
    SearchTabsType["All"] = "all";
})(SearchTabsType || (exports.SearchTabsType = SearchTabsType = {}));
//# sourceMappingURL=types.js.map